import enabledSeg from '@/vue-dlb/assets/icons/png/EnabledSeg.png';

export class MsgTree {
  constructor(id = '', name = '', parent = null) {
    this.id = id;
    this.name = name;
    this.text = name;
    this.icon = ''; //@/assets/icons/png/EnabledSeg.png';
    this.opened = false;
    this.selected = false;
    this.disabled = false;
    this.seg = "";
    this.req = "";
    this.loop = "";
    this.dataname = "";
    this.parent = parent;
    this.properties = [];
    this.items = [];
    this.itemCount = 0;
  }

  addItem(item, index = -1) {
    //console.log('-------MsgTree addItem:index('+index+')--------');
    if (index === -1) {
      this.items.push(item);
    } else {
      this.items.splice(index, 0, item);
    }
  }

  listItems() {
    let result = [];
    this.items.forEach((item) => {
      result = result.concat(item.listItems().filter(item2 => result.find(item3 => item3.name === item2.name) === undefined));
    });

    return result;
  }

  findItem(name) {
    return this.items.find(item => item.name === name);
  }

  toJson() {
    let object = {};
    //object = { id: `${this.id}`, name: `${this.name}` , text: `${this.name}`, icon: `${this.icon}` ,opened: `${this.opened}` , disabled: `${this.disabled}`};
    //object = { id: `${this.id}`, name: `${this.name}` , text: `${this.name}`, icon: `${this.icon}` ,opened: this.opened , disabled: this.disabled};
    object = { id: `${this.id}`, name: `${this.name}` , text: `${this.name}`, icon: `${this.icon}` ,opened: this.opened , disabled: this.disabled, seg: this.seg, req: this.req, loop: this.loop, dataname: this.dataname};
    object.children = [];

    this.items.forEach((item) => {
      object.children.push(item.toJson());
    });

    return object;
  }

  toJson_backup() {
    const object = {};
    const boundary = `${this.name}|B|C|999|${this.name}`;
    object.ITEM = boundary;
    object.MEMBER = [];

    this.items.forEach((item) => {
      object.MEMBER.push(item.toJson());
    });

    return object;
  }

}

// export default MsgTree;

